export const SyllabusActions = {
    GET_SYLLABUS: "GET_SYLLABUS",
    SET_SYLLABUS: "SET_SYLLABUS",
  };

  